import { useState } from 'react';
import vocab from './data/vocab';
import speaker from ".//imgs/speaker-icon.png"


function MultyChoice(num_of_choices){

  //Makes new multy choice question
  function NewEntries(num_of_choices){
    //Chooses all the definitions/words out of the whole bank randomly
    const solution_index = Math.floor(Math.random()*num_of_choices)
    const new_entries = []
    for(var i=0; i<num_of_choices; i++){
      const this_index = Math.floor(Math.random()*vocab.length)
      var correct = false
      if (i === solution_index) {correct=true}
      new_entries.push({"word": vocab[this_index]["word"], "definition": vocab[this_index]["definition"], "class_style": "nuetral", 
        "correct":correct, "vocab_index": this_index})
    }
    setEntries(new_entries)
  }


  //Makes first multy choice question
  //Chooses all the definitions/words out of the whole bank randomly
  //do this smarter, like if m=bad with word or not played in a while
  //also make sure not to have same word in one round
  const initial_entries = []
  const solution_index = Math.floor(Math.random()*num_of_choices)
  for(var i=0; i<num_of_choices; i++){
    const this_index = Math.floor(Math.random()*vocab.length)
    var correct = false
    if (i === solution_index) {correct=true}
    initial_entries.push({"word": vocab[this_index]["word"], "definition": vocab[this_index]["definition"], "class_style": "nuetral", 
                           "correct":correct, "vocab_index": this_index})
  }
  const [entries, setEntries] = useState(initial_entries);

  //Gets Stats
  function GetStats(vocab_score,vocab_streak){
    var total_correct = 0
    var total_incorrect = 0
    var amount_known = 0
    var amount_tested = 0
    vocab_score.forEach(score=>{
      total_correct += score["correct"]
      total_incorrect += score["incorrect"]
      if (score["correct"]*.75 > score["incorrect"]) amount_known += 1
      if (score["last_played"] !== 0) amount_tested += 1;
    })

    return {"total_correct": total_correct, "total_incorrect": total_incorrect, "amount_tested": amount_tested, 
      "amount_known":amount_known, "streak": vocab_streak}
  }

  //Get initial Stats
  var vocab_score = JSON.parse(localStorage.getItem("VocabScore"));
  var vocab_streak = JSON.parse(localStorage.getItem("VocabStreak"));
  if (vocab_score === null){
    vocab_score = []
    for(i=0; i<vocab.length; i++)
      vocab_score.push({"correct":0,"incorrect":0,"streak":0,"last_played":0, "vocab_index": i})
  }
  if (vocab_streak === null)
    vocab_streak = 0
  localStorage.setItem("VocabScore",JSON.stringify(vocab_score));
  localStorage.setItem("VocabStreak",JSON.stringify(vocab_streak));
  const [stats, setStats] = useState(GetStats(vocab_score,vocab_streak))

  const [params, setParams] = useState({"q_type": "definition", "a_type": "word", "checked": true})
  function ChangeQAType(){
    if(params["q_type"] === "definition")
      setParams({"q_type": "word", "a_type": "definition", "checked": false})
    
    if(params["q_type"] === "word")
      setParams({"q_type": "definition", "a_type": "word", "checked": true})
    
  }

  //When clicked
  function Clicked(this_entry){
    //if this is first click
    if(this_entry["class_style"] === "nuetral"){
      var vocab_score = JSON.parse(localStorage.getItem("VocabScore"));
      var vocab_streak = JSON.parse(localStorage.getItem("VocabStreak"));

      const this_index = this_entry["vocab_index"]
      if(this_entry["correct"]){
        vocab_score[this_index]["correct"] += 1
        vocab_score[this_index]["streak"] += 1
        vocab_streak += 1
        vocab_score[this_index]["last_played"] += new Date().getTime();
      }else{
        vocab_score[this_index]["incorrect"] += 1
        vocab_score[this_index]["streak"] = 0
        vocab_streak = 0
        vocab_score[this_index]["last_played"] += new Date().getTime();
      }
      const new_entries = []
      //change display
      entries.forEach(entry=>{
        new_entries.push(entry)
        if(entry["correct"]){
          new_entries[new_entries.length-1]["class_style"] = "correct"
        }else{
          new_entries[new_entries.length-1]["class_style"] = "incorrect"
        }
      })
      setEntries(new_entries)

      localStorage.setItem("VocabScore",JSON.stringify(vocab_score));
      localStorage.setItem("VocabStreak",JSON.stringify(vocab_streak));
      setStats(GetStats(vocab_score,vocab_streak));
  
    }else{
      NewEntries(entries.length,params)
    }
  }
  


  return(
    <div>

      <h2>{Object.keys(stats).map(key => {return <><strong>{key.toUpperCase().replace("_"," ")}: {JSON.stringify(stats[key])+"  "}</strong></>})}</h2>
      <input type='number' value={entries.length} onChange={e=> { NewEntries(e.target.value, params)}} id="numb_of_choices"></input>
      <input type='checkbox'  id="word_as_answer" defaultChecked={params["checked"]} onChange={()=>{ChangeQAType(); NewEntries(entries.length)}}></input>
      <div id="def">{entries.map(entry =>{
        if(entry["correct"]){
          if (params["q_type"] === "word")
            return <>{entry["word"]+"  "}
                        <img src={speaker} style={{width: "15px"}} alt="speaker_icon" onClick={(e)=> {new Audio(vocab[entry["vocab_index"]]["audio"]).play(); e.stopPropagation();}}>
                        </img></>
          else
            return entry["definition"]
      }})
        }</div>
   
      <div class="cards">  
        {entries.map(entry => (
          <div key={entry["word"]} class={entry["class_style"]} onClick={()=>Clicked(entry)}>
            {(() => {
              if(entry["class_style"] !== "nuetral")
                return <>{entry["word"]}
                        <img src={speaker} style={{width: "15px"}} alt="speaker_icon" onClick={(e)=> {new Audio(vocab[entry["vocab_index"]]["audio"]).play(); e.stopPropagation();}}>
                        </img>
                        <br></br>{entry["definition"]}</>
              else
                if (params["a_type"] === "word")
                  return <>{entry["word"]+"  "}
                        <img src={speaker} style={{width: "15px"}} alt="speaker_icon" onClick={(e)=> {new Audio(vocab[entry["vocab_index"]]["audio"]).play(); e.stopPropagation();}}>
                        </img></>
                else
                  return entry["definition"]
                
            })()}
          </div>
        ))}
      </div>
    </div>
  );
}
function Study() {
  return (
    <div>
      <h1>GRE Vocab</h1>
      {MultyChoice(5)}
    </div>
  );
}

export default Study;